
import Sidebar from '../components/Sidebar';

import './Bookings.css';

const Bookings = () => {

    return (

        <div className="bookings-page">

            <Sidebar />

            <div className="bookings-content">

                <h1>Bookings Management</h1>

                <p className="bookings-text">
                    Manage ticket reservations and visitor bookings.
                </p>


                {/* Stats Cards */}

                <div className="booking-cards">

                    <div className="booking-card">

                        <h2>Total Bookings</h2>

                        <h3>1,580</h3>

                    </div>


                    <div className="booking-card">

                        <h2>Pending Requests</h2>

                        <h3>48</h3>

                    </div>


                    <div className="booking-card">

                        <h2>Confirmed Tickets</h2>

                        <h3>1,120</h3>

                    </div>

                </div>



                {/* Table */}

                <div className="bookings-table">

                    <h2>Recent Bookings</h2>

                    <table>

                        <thead>

                            <tr>

                                <th>Visitor</th>
                                <th>Date</th>
                                <th>Status</th>
                                <th>Ticket</th>

                            </tr>

                        </thead>


                        <tbody>

                            <tr>

                                <td>Ahmed Ali</td>

                                <td>May 20, 2026</td>

                                <td>

                                    <span className="confirmed">

                                        Confirmed

                                    </span>

                                </td>

                                <td>VIP</td>

                            </tr>


                            <tr>

                                <td>Sara Mohamed</td>

                                <td>May 21, 2026</td>

                                <td>

                                    <span className="pending">

                                        Pending

                                    </span>

                                </td>

                                <td>Standard</td>

                            </tr>


                            <tr>

                                <td>Omar Khaled</td>

                                <td>May 22, 2026</td>

                                <td>

                                    <span className="confirmed">

                                        Confirmed

                                    </span>

                                </td>

                                <td>Premium</td>

                            </tr>

                        </tbody>

                    </table>

                </div>

            </div>

        </div>

    );
}

export default Bookings;